import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaginationPipe} from './pagination/pagination.pipe';
import { ProfilePicturePipe } from './profilePicture/profilePicture.pipe';
import { ChatPersonSearchPipe } from './search/chat-person-search.pipe';
import { UserSearchPipe } from './search/user-search.pipe';
import { ClientSearchPipe } from './search/client-search.pipe';
import { TruncatePipe } from './truncate/truncate.pipe';
import { MailSearchPipe } from './search/mail-search.pipe';
import { HasCustomPermissionAuthPipe } from './custom-permission/has-custom-permission-auth.pipe';

@NgModule({
    imports: [ 
        CommonModule 
    ],
    declarations: [
        PaginationPipe,
        ProfilePicturePipe,
        ChatPersonSearchPipe,
        UserSearchPipe,
        ClientSearchPipe,
        TruncatePipe,
        MailSearchPipe,
        HasCustomPermissionAuthPipe
    ],
    exports: [
        PaginationPipe,
        ProfilePicturePipe,
        ChatPersonSearchPipe,
        UserSearchPipe,
        ClientSearchPipe,
        TruncatePipe,
        MailSearchPipe,
        HasCustomPermissionAuthPipe
    ]
})
export class PipesModule { }
